"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const UserContext = react_1.default.createContext({
    user: undefined
});
function withUser(WrappedComponent) {
    const UserContextWrapper = props => (react_1.default.createElement(UserContext.Consumer, null, ({ user }) => user ? react_1.default.createElement(WrappedComponent, Object.assign({}, props, { user: user })) : null));
    UserContextWrapper.displayName = WrappedComponent.displayName;
    return UserContextWrapper;
}
exports.withUser = withUser;
exports.useUser = () => {
    const { user } = react_1.useContext(UserContext);
    return user;
};
exports.UserContextProvider = UserContext.Provider;
